import { create } from 'zustand'

interface OrderByCodeStateInterface {
  columnsKeys: string[]
  duplicateOrderProductsQuantities: { [x: string]: number }
  setDuplicateOrderProductsQuantities: (duplicateProductsQuantities: {
    [x: string]: number
  }) => void
  setColumnsKeys: (columnKeys: string[]) => void
  setInitialOrderByCodeStore: () => void
}

const initialState = {
  columnsKeys: [],
  duplicateOrderProductsQuantities: {},
}

export const useOrderByCodeStore = create<OrderByCodeStateInterface>((set) => ({
  ...initialState,
  setDuplicateOrderProductsQuantities: (duplicateOrderProductsQuantities: {
    [x: string]: number
  }) => {
    set({ duplicateOrderProductsQuantities })
  },
  setColumnsKeys: (columnsKeys: string[]) => {
    set({ columnsKeys })
  },
  setInitialOrderByCodeStore: () => set({ ...initialState }),
}))
